'use client'
import promoCardsData from '@/src/constants/hotels/homePromoCards.json'
import { useIsHeya } from '@/src/hooks/useThemeKey'
import { useLocale, useTranslations } from 'next-intl'
import { useMemo } from 'react'
import HomePromoCards, { PromoCard } from './homePromoCards'

// Logic layer: resolves the localized promo cards (ported from me-flyin's adsBg block —
// luxury / ladies-only + email capture / fun-filled family) into the card view models.
const HomePromoCardsWrapper: React.FC = () => {
    const t = useTranslations('homePage.headings')
    const locale = useLocale()
    const isArabic = locale === 'ar'
    const isHeya = useIsHeya()

    const cards = useMemo<PromoCard[]>(
        () =>
            promoCardsData.cards.map(card => ({
                id: card.id,
                kind: card.kind as PromoCard['kind'],
                title: isArabic ? card.title_ar || card.title_en : card.title_en,
                description: isArabic ? card.desc_ar || card.desc_en : card.desc_en,
                imageUrl: card.imageUrl,
                href: isArabic ? card.href_ar || card.href_en : card.href_en,
                ctaLabel: card.cta ? t(card.cta) : undefined
            })),
        [isArabic, t]
    )

    // Heya hosts do not show the promo cards.
    if (isHeya || cards.length === 0) return null

    return <HomePromoCards cards={cards} getNowLabel={t('getNow')} emailPlaceholder={t('emailPlaceholder')} />
}

export { HomePromoCardsWrapper }
export default HomePromoCardsWrapper
